import React from 'react';
import DashboardLayout from '../components/Layout/DashboardLayout';
import FinancialConsultantChat from '../components/FinancialConsultantChat';

const AdminFinancialConsultantPage = () => {
  return (
    <DashboardLayout userType="admin">
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
          <div>
            <h2 style={{ margin: 0, fontWeight: 900, color: 'var(--info-text)' }}>💰 Consultor Financeiro IA</h2>
            <div style={{ marginTop: 6, color: 'var(--info)', fontWeight: 600 }}>
              Modo consultor (KPIs + alertas + ações) com dados reais do ERP.
            </div>
          </div>
        </div>

        <div style={{ marginTop: 14 }}>
          <FinancialConsultantChat conversationId="admin-financial-consultant-fullpage" height={640} />
        </div>

        <div style={{ marginTop: 12, color: 'var(--info)', fontSize: 12 }}>
          Dica: faz perguntas como “Analisa-me o cashflow”, “Onde devo atuar esta semana?”, “Top devedores e ações”.
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AdminFinancialConsultantPage;
